function toggleProductGrid(columns) {
    const productGrid = document.getElementById('st-collection-product-list');
    if (!productGrid) return;

    // Remove all grid classes
    productGrid.classList.remove(
        'collection__page-products-1',
        'collection__page-products-2',
        'collection__page-products-3',
        'collection__page-products-4',
        'collection__page-products'
    );

    // Add appropriate class
    if (columns === 4) {
        productGrid.classList.add('collection__page-products');
    } else {
        productGrid.classList.add(`collection__page-products-${columns}`);
    }

    // Update button UI states
    document.querySelectorAll('.searchtap-temp .st-product-grid-changer button').forEach(button => {
        const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
        const svgRects = button.querySelectorAll('svg rect');
        const svgPaths = button.querySelectorAll('svg path');

        if (buttonColumns === columns) {
            button.classList.add('active', '!st-bg-[#333]');
            button.classList.remove('st-bg-[#fff]');
            svgRects.forEach(rect => rect.setAttribute('fill', '#fff'));
            svgPaths.forEach(path => path.setAttribute('fill', '#fff'));
        } else {
            button.classList.remove('active', '!st-bg-[#333]');
            button.classList.add('st-bg-[#fff]');
            svgRects.forEach(rect => rect.setAttribute('fill', '#333'));
            svgPaths.forEach(path => path.setAttribute('fill', '#333'));
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const productGrid = document.getElementById('st-collection-product-list');
    const gridButtons = document.querySelectorAll('.st-product-grid-changer button');

    // Default to 4 columns on desktop, 1 column on mobile
    const initialColumns = window.innerWidth <= 768 ? 2 : 4;
    toggleProductGrid(initialColumns);
});